import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {  UserMeInput, UserMeOutput } from "../models/users.model";
import { RestService } from "./rest.service";

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  constructor(private rest: RestService) { }
  getMyProfile(): Observable<UserMeOutput> {
    return this.rest.get$<UserMeOutput>("me", true, 'user');
  }

  saveMyProfile(newUserInfo: UserMeInput): Observable<string> {
    return this.rest.putEmptyResponse$("me", { ...newUserInfo }, 'user');
  }

  saveMyAvatar(selectedFile: File): Observable<{ url?: string | undefined }> {
    const fd = new FormData();
    fd.append("avatar", selectedFile, selectedFile.name);
    return this.rest.post$<{ url?: string | undefined }>(
      "me/avatar",
      fd,
      false, 'user'
    );
  }

  // deleteMyAvatar(): Observable<string> {
  //   return this.rest.delete("users/me/avatar").pipe(switchMap(() => of("OK")));
  // }
}
